<template>
  <div class="container content-padding box-bg">
    <div class="container-main">
      <div class="container-main-header">
        <div class="search-box" style="padding-bottom: 0px">
          <div class="index-top-box">
            <font class="index-search-font" style="font-size: 16px"
              >智能控制</font
            >
            <span class="index-top-title" style="font-size: 16px"
              >/添加触发条件</span
            >
          </div>
          <div style="height: 16px"></div>
          <div class="top-opption" style="bottom: 19px">
            <el-button
              type="primary"
              class="left"
              @click="handleAdd()"
              v-if="tableData.length > 0"
              >+添加触发条件</el-button
            >
            <el-button type="primary" class="step-positon" @click="goTo()"
              >上一步</el-button
            >
            <el-button type="primary" class="step-positon" @click="goTo2()"
              >下一步</el-button
            >
          </div>
        </div>
      </div>

      <div class="equipmentlist box-padding-mide">
        <div class="mudel-left-box">
          <div class="container-content-head">
            <span class="title">添加触发条件</span>
          </div>
          <div class="container-content tablecontent" style="height: 800px">
            <div class="equipmentcenter">
              <el-steps :active="1" align-center>
                <el-step title="添加控制"></el-step>
                <el-step title="添加触发条件"></el-step>
                <el-step title="添加执行动作"></el-step>
              </el-steps>
            </div>
            <div class="equipmentcenter-step-box"></div>
            <div
              class="equipmentcenter-opption-box inside-box"
              v-if="tableData.length == 0"
              style="width: 900px; border: none !important"
            >
              <el-form
                :inline="true"
                ref="form"
                :model="form"
                :rules="rules"
                label-width="100px"
              >
                <el-form-item label="设备类型：" prop="type">
                  <el-select
                    v-model="form.type"
                    placeholder="请选择设备类型"
                    @change="deviceTypeChange"
                    style="width: 668px"
                  >
                    <el-option
                      v-for="(item, index) in deviceTypeArr"
                      :key="index"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="设备名称：" prop="eid">
                  <el-select
                    v-model="form.eid"
                    placeholder="请选择设备名称"
                    @change="deviceChange"
                    style="width: 668px"
                  >
                    <el-option
                      v-for="(item, index) in deviceArray"
                      :key="index"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <ul v-for="(item2, index2) in form.conditionList" :key="index2">
                  <el-form-item label="属性名称：">
                    <el-select
                      v-model="item2.attributeId"
                      placeholder="请选择属性名称"
                      style="width: 160px"
                      @change="attributeChange(index2)"
                    >
                      <el-option
                        v-for="(item3, index3) in attributeArray"
                        :key="index3"
                        :label="item3.name"
                        :value="item3.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <div style="display: inline-block">
                    <el-form-item
                      v-if="item2.switchType == '-1'"
                      label="大于"
                      label-width="50px !important"
                    >
                      <el-input-number
                        placeholder="请输入"
                        v-model="item2.startValue"
                        :min="-99999999"
                        :max="999999999"
                        :precision="2"
                        :step="1"
                        size="small"
                        clearable
                        style="width: 150px !important"
                      ></el-input-number>
                    </el-form-item>
                    <el-form-item
                      v-if="item2.switchType == '-1'"
                      label="小于"
                      label-width="50px !important"
                    >
                      <el-input-number
                        placeholder="请输入"
                        v-model="item2.endValue"
                        :min="-99999999"
                        :max="999999999"
                        :precision="2"
                        :step="1"
                        size="small"
                        clearable
                        style="width: 150px !important"
                      ></el-input-number>
                    </el-form-item>
                    <el-form-item
                      v-if="item2.switchType == '1' || item2.switchType == '4'"
                      label="大于"
                      label-width="50px !important"
                    >
                      <el-input-number
                        placeholder="请输入"
                        v-model="item2.startValue"
                        :min="0"
                        :max="100"
                        :step="1"
                        size="small"
                        clearable
                        style="width: 150px !important"
                      ></el-input-number>
                    </el-form-item>
                    <el-form-item
                      v-if="item2.switchType == '1' || item2.switchType == '4'"
                      label="小于"
                      label-width="50px !important"
                    >
                      <el-input-number
                        placeholder="请输入"
                        v-model="item2.endValue"
                        :min="0"
                        :max="100"
                        :step="1"
                        size="small"
                        clearable
                        style="width: 150px !important"
                      ></el-input-number>
                    </el-form-item>
                    <el-select
                      v-if="
                        item2.switchType == '0' ||
                        item2.switchType == '3' ||
                        item2.switchType == '2'
                      "
                      v-model="item2.startValue"
                      placeholder="请选择"
                      class="select-class"
                    >
                      <el-option label="开启" value="1"></el-option>
                      <el-option label="关闭" value="0"></el-option>
                    </el-select>
                    <el-select
                      v-if="item2.switchType == '5'"
                      v-model="item2.startValue"
                      placeholder="请选择"
                      class="select-class"
                    >
                      <el-option label="停止" value="0"></el-option>
                      <el-option label="正开" value="1"></el-option>
                      <el-option label="反开" value="2"></el-option>
                    </el-select>
                    <el-select
                      v-if="item2.switchType == '6'"
                      v-model="item2.startValue"
                      placeholder="请选择"
                      class="select-class"
                    >
                      <el-option label="展开停止" value="0"></el-option>
                      <el-option label="收缩停止" value="1"></el-option>
                      <el-option label="展开" value="2"></el-option>
                      <el-option label="收缩" value="3"></el-option>
                    </el-select>
                    <el-select
                      v-if="item2.switchType == '7'"
                      v-model="item2.startValue"
                      placeholder="请选择"
                      class="select-class"
                    >
                      <el-option label="下发" value="0"></el-option>
                    </el-select>
                    <el-select
                      v-if="item2.switchType == '8'"
                      v-model="item2.startValue"
                      placeholder="请选择"
                      class="select-class"
                    >
                      <el-option
                        v-for="(item4, index4) in item2.customSwitchCmds"
                        :key="index4"
                        :label="item4.name"
                        :value="item4.id + ''"
                      ></el-option>
                    </el-select>
                  </div>
                  <a class="a-class" @click="delAttribute(index2)">删除</a>
                </ul>
                <el-form-item style="width: 400px; padding-left: 142px">
                  <a class="td-opption" @click="addAttribute()"
                    >+添加动作属性</a
                  >
                </el-form-item>
                <el-form-item style="text-align: center; margin-top: 20px">
                  <el-button
                    type="primary"
                    style="width: 120px"
                    @click="handleSave()"
                    >保存</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <div
              class="container-content tablecontent"
              v-if="tableData.length > 0"
            >
              <el-table
                class="data-table"
                style="width: 100%"
                :data="tableData"
                align="center"
                :header-cell-style="{ background: '#F6F6F6' }"
                v-loading="isloading"
              >
                <el-table-column label="设备类型">
                  <template slot-scope="scope">
                    <p>{{ scope.row.type | devicetype }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="设备名称">
                  <template slot-scope="scope">
                    <p>{{ scope.row.deviceName }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="属性名称">
                  <template slot-scope="scope">
                    <p>{{ scope.row.attributeName }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="触发条件">
                  <template slot-scope="scope">
                    <p>{{ scope.row.condition }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                  <template slot-scope="scope">
                    <a
                      class="td-opption"
                      @click="
                        handleUpdate(
                          scope.row.id,
                          scope.row.type,
                          scope.row.eid,
                          scope.row.switchType
                        )
                      "
                      >编辑</a
                    >
                    <a class="td-opption del" @click="handleDel(scope.row.id)"
                      >删除</a
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-dialog
              :title="title"
              :visible.sync="dialogVisible"
              width="880px"
              :before-close="handleClose"
            >
              <div class="equipmentcenter-opption-box">
                <el-form
                  :inline="true"
                  ref="form"
                  :rules="rules"
                  :model="form"
                  label-width="100px"
                >
                  <el-form-item label="设备类型：" prop="type">
                    <el-select
                      v-model="form.type"
                      placeholder="请选择设备类型"
                      @change="deviceTypeChange"
                      style="width: 587px"
                    >
                      <el-option
                        v-for="(item, index) in deviceTypeArr"
                        :key="index"
                        :label="item.name"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="设备名称：" prop="eid">
                    <el-select
                      v-model="form.eid"
                      placeholder="请选择设备名称"
                      @change="deviceChange"
                      style="width: 587px"
                    >
                      <el-option
                        v-for="(item, index) in deviceArray"
                        :key="index"
                        :label="item.name"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <ul
                    style="position: relative"
                    v-for="(item2, index2) in form.conditionList"
                    :key="index2"
                  >
                    <el-form-item label="属性名称：">
                      <el-select
                        v-model="item2.attributeId"
                        placeholder="请选择属性名称"
                        style="width: 160px"
                        @change="attributeChange(index2)"
                      >
                        <el-option
                          v-for="(item3, index3) in attributeArray"
                          :key="index3"
                          :label="item3.name"
                          :value="item3.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <div style="display: inline-block">
                      <el-form-item
                        v-if="item2.switchType == '-1'"
                        label="大于"
                        label-width="50px !important"
                      >
                        <el-input-number
                          placeholder="请输入"
                          v-model="item2.startValue"
                          :min="-99999999"
                          :max="99999999"
                          :precision="2"
                          :step="1"
                          size="small"
                          clearable
                          style="width: 150px !important"
                        ></el-input-number>
                      </el-form-item>
                      <el-form-item
                        v-if="item2.switchType == '-1'"
                        label="小于"
                        label-width="50px !important"
                      >
                        <el-input-number
                          placeholder="请输入"
                          v-model="item2.endValue"
                          :min="-99999999"
                          :max="99999999"
                          :precision="2"
                          :step="1"
                          size="small"
                          clearable
                          style="width: 150px !important"
                        ></el-input-number>
                      </el-form-item>
                      <el-form-item
                        v-if="
                          item2.switchType == '1' || item2.switchType == '4'
                        "
                        label="大于"
                        label-width="50px !important"
                      >
                        <el-input-number
                          placeholder="请输入"
                          v-model="item2.startValue"
                          :min="0"
                          :max="100"
                          :step="1"
                          size="small"
                          clearable
                          style="width: 150px !important"
                        ></el-input-number>
                      </el-form-item>
                      <el-form-item
                        v-if="
                          item2.switchType == '1' || item2.switchType == '4'
                        "
                        label="小于"
                        label-width="50px !important"
                      >
                        <el-input-number
                          placeholder="请输入"
                          v-model="item2.endValue"
                          :min="0"
                          :max="100"
                          :step="1"
                          size="small"
                          clearable
                          style="width: 150px !important"
                        ></el-input-number>
                      </el-form-item>
                      <el-form-item
                        v-if="
                          item2.switchType == '0' ||
                          item2.switchType == '3' ||
                          item2.switchType == '2'
                        "
                      >
                        <el-select
                          v-model="item2.startValue"
                          placeholder="请选择"
                          class="select-class2"
                        >
                          <el-option label="开启" value="1"></el-option>
                          <el-option label="关闭" value="0"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item v-if="item2.switchType == '5'">
                        <el-select
                          v-model="item2.startValue"
                          placeholder="请选择"
                          class="select-class2"
                        >
                          <el-option label="停止" value="0"></el-option>
                          <el-option label="正开" value="1"></el-option>
                          <el-option label="反开" value="2"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item v-if="item2.switchType == '6'">
                        <el-select
                          v-model="item2.switchType.startValue"
                          placeholder="请选择"
                          class="select-class2"
                        >
                          <el-option label="展开停止" value="0"></el-option>
                          <el-option label="收缩停止" value="1"></el-option>
                          <el-option label="展开" value="2"></el-option>
                          <el-option label="收缩" value="3"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item v-if="item2.switchType == '7'">
                        <el-select
                          v-model="item2.switchType.startValue"
                          placeholder="请选择"
                          class="select-class2"
                        >
                          <el-option label="下发" value="0"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item v-if="item2.switchType == '8'">
                        <el-select
                          v-model="item2.startValue"
                          placeholder="请选择"
                          class="select-class2"
                        >
                          <el-option
                            v-for="(item4, index4) in item2.customSwitchCmds"
                            :key="index4"
                            :label="item4.name"
                            :value="item4.id + ''"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <a class="a-class2" @click="delAttribute(index2)">删除</a>
                  </ul>
                  <el-form-item>
                    <a class="td-opption" @click="addAttribute()"
                      >+添加动作属性</a
                    >
                  </el-form-item>
                  <el-form-item
                    style="
                      text-align: center;
                      margin-top: 20px;
                      margin-left: 118px;
                    "
                  >
                    <el-button
                      type="info"
                      style="width: 120px"
                      @click="handleClose()"
                      >取消</el-button
                    >
                    <el-button
                      type="primary"
                      style="width: 120px"
                      @click="handleSave()"
                      >保存</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </el-dialog>
          </div>
        </div>
        <div class="mudel-right-box">
          <div class="mudel-right-box-box" style="height: 860px">
            <div
              class="container-content-head"
              style="border-bottom: 1px solid #f4f8f9"
            >
              <i class="top-nav"></i>
              <span class="title">词条注释</span>
            </div>
            <div class="mudel-expalin">
              <p>
                当第一步设置的是"定时"控制类型时，当前步骤配置的是设备主动触发动作时需要的时间节点范围，当第一步设置的是"自动"控制类型时，当前步骤配置的是设备主动触发动作时属性所达到的范围值
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
export default {
  name: "equipmentcenter",
  components: {},
  data() {
    return {
      form: {
        linkageControlId: "",
        type: "",
        eid: "",
        conditionList: [
          {
            linkageControlId: "",
            type: "0",
            eid: "",
            attributeId: "",
            startValue: undefined,
            endValue: undefined,
            switchType: "-1",
          },
        ],
      },
      rules: {
        type: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "change",
          },
        ],
        eid: [
          {
            required: true,
            message: "请选择设备名称",
            trigger: "change",
          },
        ],
      },
      tableData: [],
      deviceTypeArr: [
        // 设备类型
        {
          name: "数值设备",
          value: "0",
        },
        {
          name: "开关设备",
          value: "3",
        },
      ],
      dialogVisible: false,
      title: "添加设备属性",
      deviceArray: [], // 设备集合
      attributeArray: [], // 属性集合
      linkageControlId: "", // 联动控制id
      controlType: "", // 控制类型
    };
  },
  computed: {
    ...mapState("user", ["token"]),
  },
  mounted() {
    this.linkageControlId = sessionStorage.getItem("projectEditId");
    this.controlType = sessionStorage.getItem("kztype");

    // 获取触发条件列表
    this.getList();
  },
  methods: {
    // 上一步
    goTo() {
      this.$router.push({
        name: `Linkagecenter1`,
      });
    },
    // 下一步
    goTo2() {
      this.$router.push({
        name: `Linkagecenter3`,
      });
    },
    // 保存
    handleSave() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$toaster.error("请填写完整的信息");
          return;
        }

        let length = this.form.conditionList.length;
        if (length == 0) {
          this.$toaster.error("请至少添加一个动作属性");
          return;
        }

        for (var i = 0; i < length; i++) {
          this.form.conditionList[i].type = this.form.type;
          this.form.conditionList[i].eid = this.form.eid;
          this.form.conditionList[i].linkageControlId = this.linkageControlId;
          this.form.conditionList[i].controlType = this.controlType;

          if (this.form.conditionList[i].attributeId == "") {
            this.$toaster.error("请选择动作属性");
            return;
          }

          if (
            this.form.conditionList[i].switchType == "-1" ||
            this.form.conditionList[i].switchType == "1" ||
            this.form.conditionList[i].switchType == "4"
          ) {
            // 数值设备、模拟设备
            if (
              (this.form.conditionList[i].startValue === undefined ||
                this.form.conditionList[i].startValue === "") &&
              (this.form.conditionList[i].endValue === undefined ||
                this.form.conditionList[i].endValue === "")
            ) {
              this.$toaster.error("大于小于至少输入一个");
              return;
            }

            if (
              this.form.conditionList[i].startValue !== undefined &&
              this.form.conditionList[i].startValue !== "" &&
              this.form.conditionList[i].endValue !== undefined &&
              this.form.conditionList[i].endValue !== "" &&
              this.form.conditionList[i].startValue >
                this.form.conditionList[i].endValue
            ) {
              this.$toaster.error("大于数值不能大于小于数值");
              return;
            }
          } else {
            if (
              this.form.conditionList[i].startValue === undefined ||
              this.form.conditionList[i].startValue === ""
            ) {
              this.$toaster.error("请选择属性状态");
              return;
            }
          }
        }

        this.form.token = this.token;
        this.form.linkageControlId = this.linkageControlId;

        this.$api.device.saveLinkageControlCondition(this.form).then((res) => {
          if (res.code == 200) {
            this.$toaster.ok(res.smg);
            this.getList();
            this.handleClose();
          }
        });
      });
    },
    // 添加
    handleAdd() {
      this.title = "添加触发条件";
      // 清空原数据
      this.form = {
        id: undefined,
        eid: "",
        linkageControlId: this.form.linkageControlId,
        conditionList: [
          {
            linkageControlId: "",
            type: "",
            eid: "",
            attributeId: "",
            startValue: undefined,
            endValue: undefined,
            switchType: "-1",
          },
        ],
      };
      this.dialogVisible = true;
    },
    // 编辑
    handleUpdate(id, type, eid) {
      this.title = "编辑触发条件";
      // 清空原数据
      this.form = {
        id: id,
        linkageControlId: this.linkageControlId,
        type: type,
        eid: eid,
        conditionList: [
          {
            linkageControlId: "",
            type: "",
            eid: "",
            attributeId: "",
            startValue: undefined,
            endValue: undefined,
            switchType: "-1",
          },
        ],
      };

      // 获取自动条件详情
      this.getDetail();
      this.dialogVisible = true;
      this.$forceUpdate();
    },
    // 删除
    handleDel(id) {
      this.$confirm("是否确定删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$api.device
          .delfun("pc/linkageControl/deleteLinkageControlCondition", id)
          .then((res) => {
            if (res.code == 200) {
              this.getList();
              this.$toaster.ok(res.msg);
            }
          });
      });
    },
    // 获取列表
    getList() {
      this.isloading = true;
      this.$api.device
        .getConditionListByControlId(this.linkageControlId)
        .then((res) => {
          if (res.code == 200) {
            for (var i = 0; i < res.data.length; i++) {
              if (
                res.data[i].switchType == 0 ||
                res.data[i].switchType == 3 ||
                res.data[i].switchType == 2
              ) {
                // 基础开关、只读开关
                if (res.data[i].startValue == 0) {
                  res.data[i].condition = "关闭";
                } else if (res.data[i].startValue == 1) {
                  res.data[i].condition = "开启";
                }
              } else if (res.data[i].switchType == 5) {
                // 正反转开关
                if (res.data[i].startValue == 0) {
                  res.data[i].condition = "停止";
                } else if (res.data[i].startValue == 1) {
                  res.data[i].condition = "正开";
                } else if (res.data[i].startValue == 2) {
                  res.data[i].condition = "反开";
                }
              } else if (res.data[i].switchType == 6) {
                // 展开收缩开关
                if (res.data[i].startValue == 0) {
                  res.data[i].condition = "展开停止";
                } else if (res.data[i].startValue == 1) {
                  res.data[i].condition = "收缩停止";
                } else if (res.data[i].startValue == 2) {
                  res.data[i].condition = "展开";
                } else if (res.data[i].startValue == 3) {
                  res.data[i].condition = "收缩";
                }
              } else if (res.data[i].switchType == 7) {
                // 下发开关
                res.data[i].condition = "下发";
              } else if (res.data[i].switchType == 8) {
                // 自定义开关
                res.data[i].condition = res.data[i].switchCmdName;
              } else {
                // 数值设备、模拟开关
                if (res.data[i].endValue == undefined) {
                  res.data[i].condition = "≥" + res.data[i].startValue;
                } else if (res.data[i].startValue == undefined) {
                  res.data[i].condition = "≤" + res.data[i].endValue;
                } else {
                  res.data[i].condition =
                    "≥" + res.data[i].startValue + "且≤" + res.data[i].endValue;
                }
              }
            }
            this.tableData = res.data;
            this.isloading = false;
          }
        });
    },
    // 获取详情
    getDetail() {
      this.$api.device.getConditionById(this.form.id).then((res) => {
        if (res.code == 200) {
          var obj = {};
          obj.eid = res.data[0].eid;
          obj.type = res.data[0].type.toString();
          obj.linkageControlId = res.data[0].linkageControlId;

          var arr = [];
          for (var i = 0; i < res.data.length; i++) {
            res.data[i].startValue =
              res.data[i].startValue != undefined
                ? res.data[i].startValue.toString()
                : undefined;
            res.data[i].endValue =
              res.data[i].endValue != undefined
                ? res.data[i].endValue.toString()
                : undefined;

            arr.push(res.data[i]);
          }

          obj.conditionList = arr;
          this.form = obj;
          this.isloading = false;

          if (this.form.type == 0) {
            // 数值
            this.getNumericalList();
            this.getNumericalAttributes();
          } else if (this.form.type == 3) {
            // 开关
            this.getSwitchList();
            this.getSwitchAttributes();
          }
        }
      });
    },
    // 添加属性
    addAttribute: function () {
      let cope = {
        linkageControlId: "",
        type: "",
        eid: "",
        attributeId: "",
        startValue: undefined,
        endValue: undefined,
        switchType: "-1",
      };
      this.form.conditionList.push(cope);
    },
    // 删除属性
    delAttribute: function (index) {
      this.form.conditionList.splice(index, 1);
    },
    // 关闭窗口
    handleClose() {
      this.dialogVisible = false;
    },
    // 获取数值设备列表
    getNumericalList() {
      this.$api.device.getDeviceSwtichList2(1, 1000).then((res) => {
        if (res.code == 200) {
          this.deviceArray = [];
          for (var i = 0; i < res.data.length; i++) {
            var obj = {};
            obj.name = res.data[i].name;
            obj.value = res.data[i].id;
            this.deviceArray.push(obj);
          }
        }
      });
    },
    // 获取开关设备列表
    getSwitchList() {
      this.$api.device.getAllDeviceSwitchs().then((res) => {
        if (res.code == 200) {
          this.deviceArray = [];
          for (var i = 0; i < res.data.length; i++) {
            var obj = {};
            obj.name = res.data[i].name;
            obj.value = res.data[i].id;
            this.deviceArray.push(obj);
          }
        }
      });
    },
    // 设备类型下来切换
    deviceTypeChange() {
      this.devicetype = this.form.type;
      this.form.conditionList = [
        {
          linkageControlId: "",
          type: "",
          eid: "",
          attributeId: "",
          startValue: undefined,
          endValue: undefined,
          switchType: "-1",
        },
      ];
      this.form.eid = "";
      this.deviceArray = [];
      this.attributeArray = [];
      if (this.form.type == 0) {
        // 数值
        this.getNumericalList();
      } else if (this.form.type == 3) {
        // 开关
        this.getSwitchList();
      }
    },
    // 设备下拉切换
    deviceChange() {
      this.form.conditionList = [
        {
          linkageControlId: "",
          type: "",
          eid: "",
          attributeId: "",
          startValue: undefined,
          endValue: undefined,
          switchType: "-1",
        },
      ];
      this.attributeArray = [];
      if (this.form.type == 0) {
        // 数值
        this.getNumericalAttributes();
      } else if (this.form.type == 3) {
        // 开关
        this.getSwitchAttributes();
      }
    },
    // 获取数值设备属性列表
    getNumericalAttributes() {
      if (this.form.eid == "") {
        return;
      }
      this.attributeArray = [];
      this.$api.device.getAttributesByEid(this.form.eid).then((res) => {
        if (res.code == 200) {
          for (var i = 0; i < res.data.length; i++) {
            var obj = {};
            obj.id = res.data[i].id;
            obj.name = res.data[i].cname;
            obj.switchType = -1;
            obj.customSwitchCmds = [];
            this.attributeArray.push(obj);
          }

          // 遍历给条件赋值开关类型
          this.conditionToSwitchType();
        }
      });
    },
    // 获取开关设备属性
    getSwitchAttributes() {
      if (this.form.eid == "") {
        return;
      }
      this.attributeArray = [];
      this.$api.device.getAttributesBySwtichId(this.form.eid).then((res) => {
        if (res.code == 200) {
          for (var i = 0; i < res.data.length; i++) {
            var obj = {};
            obj.id = res.data[i].id;
            obj.name = res.data[i].cname;
            obj.switchType = res.data[i].switchType;
            obj.customSwitchCmds = res.data[i].customSwitchCmds;
            this.attributeArray.push(obj);
          }

          // 遍历给条件赋值开关类型
          this.conditionToSwitchType();
        }
      });
    },
    // 遍历给条件赋值开关类型
    conditionToSwitchType() {
      var len = this.form.conditionList.length;
      for (var i = 0; i < len; i++) {
        // 属性下拉切换，处理开关类型以及开关命令
        this.conditionToSingleSwitchType(i);
      }
    },
    // 给条件赋值开关类型
    conditionToSingleSwitchType(index) {
      // 属性id
      var attrbuteId = this.form.conditionList[index].attributeId;

      if (this.form.type == 0) {
        this.form.conditionList[index].switchType = -1;
      } else if (this.form.type == 3) {
        this.attributeArray.forEach((val) => {
          if (attrbuteId == val.id) {
            this.form.conditionList[index].switchType = val.switchType;
            this.form.conditionList[index].customSwitchCmds =
              val.customSwitchCmds;
            return true;
          }
        });
      }
    },
    // 属性下拉切换
    attributeChange(index) {
      // 清空属性状态
      this.form.conditionList[index].startValue = undefined;
      this.form.conditionList[index].endValue = undefined;
      this.conditionToSingleSwitchType(index);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.box-padding {
  padding: 20px;
}
.box-bg {
  background: #fff;
}
.sc-btn {
  color: #20a9fd;
  position: absolute;
  top: 10px;
  right: 0px;
  cursor: pointer;
}

.a-class {
  color: #20a9fd;
  position: absolute;
  right: 240px;
  cursor: pointer;
  margin-top: 10px;
}

.a-class2 {
  color: #20a9fd;
  position: absolute;
  top: 10px;
  right: 0px;
  cursor: pointer;
}

.select-class {
  width: 160px !important;
  margin-top: 2px;
}

.select-class2 {
  width: 160px !important;
}
</style>